import React, { useEffect, useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import styles from './EditFirePanel-styles.module.scss';
import classnames from 'classnames';
import Add from '@material-ui/icons/Add';
import Mesh from '../Mesh/Mesh';
// import { intersectionMesh } from '../../../../../../utils/Common';
//redux
import { useDispatch, useSelector } from 'react-redux';
import { doGetMeshList } from '../../../../../../redux/thunks/mesh';
import { editFirePanel } from '../../../../../../redux/thunks/firepanel';
import Modal from '../../../../../../components/Modals/Modal';
// import TextInput from '../../../../../../components/TextInput';
import TextInput from '../../../../../../components/Inputs/TextInput';
import SquareDelete from '../../../../../../components/SquareDelete/SquareDelete';

import Dropdown from '../../../../../../components/Inputs/Dropdown';
import ButtonCustom from '../../../../../../components/Buttons/Button';
import { Dialog } from '@material-ui/core';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import Typography from '../../../../../../components/Typography/Typography';
import FlexRow from '../../../../../../components/FlexBox/FlexRow';
import SButton from '../../../../../../components/SButton/SButton';
import { PlusIcon } from '@phosphor-icons/react';
import useIsMobile from '../../../../../../hooks/useIsMobile';
import SDialog from '../../../../../../components/SDialog/SDialog';

const EditFirePanel = ({ togglePopup, data, useMesh }) => {

  const isMobile = useIsMobile();
  const { customerId } = useParams();
  const dispatch = useDispatch();

  const currentPartner = useSelector((state) => state.auth.currentPartner);

  //state
  const [firePanelData, setFirePanelData] = useState({
    name: '',
    siteId: '',
    siteName: '',
    networkId: '',
    meshIos: {},
  });

  const [, setDisableButton] = useState(true);
  // maintaining a state to not delete a meshio in case if there is only one meshio
  const [errorDelete, setErrorDelete] = useState('');
  const meshIOs = useSelector((state) => state.mesh.meshIOs);

  const popupToggle = () => {
    togglePopup && togglePopup();
  };
  // const getMeshIoUnderSite = useCallback(() => {
  //   const siteId = data.siteId; // Assuming you have site information in the data object
  //   if (siteId) {
  //     const meshData = data.meshios; // Assuming you have meshData in the data object
  //     if (meshData?.meshIOs) {
  //       setMeshIO(meshData.meshios);
  //       // getDetail();
  //     }
  //   }
  // }, [data.meshios, data.siteId, setMeshIO]);

  useEffect(() => {
    // getMeshIoUnderSite();
    if (data?.name && data?.siteName) {
      setFirePanelData(prev => ({
        ...prev,
        name: data.name,
        siteName: data.siteName,
        siteId: data.siteId,
        networkId: data.networkId,
      }))
    }
    if (data?.meshios && data?.meshios.length > 0) {
      const t = {};
      data.meshios.forEach((item, index) => {
        const filtered = meshIOs.filter((i) => i.serialNumber === item.serialNumber);
        t[index] = {
          serialNumber: item.serialNumber,
          pins: item.pins,
          show: false,
          local: false,
          selected: JSON.parse(JSON.stringify(filtered)),
          previous: JSON.parse(JSON.stringify(filtered)),
        };
      });
      setFirePanelData(prev => ({ ...prev, meshIos: t }))
    } else {
      setFirePanelData(prev => ({ ...prev, meshIos: {} }))
    }
  }, [
    data.name,
    data.siteName,
    data.siteId,
    data.networkId,
    data.meshios,
    meshIOs,
    setFirePanelData,
  ]);

  const getFilteredMesh = (serialNumber) => {
    const filtered = meshIOs.filter((item) => item.serialNumber === serialNumber);
    if (filtered.length > 0) {
      return filtered[0];
    } else {
      return {};
    }
  };

  // useEffect(() => {
  //   if (data.siteId !== '') {
  //     getMeshIoUnderSite(data.siteId);
  //   }
  // }, [data.siteId, getMeshIoUnderSite]);

  const getMeshList = useCallback(() => {
    if (currentPartner && customerId) dispatch(doGetMeshList(currentPartner.partnerId, customerId));
  }, [currentPartner, customerId, dispatch]);

  useEffect(() => {
    getMeshList();
  }, [getMeshList]);

  // useEffect(() => {
  //   const arr = meshIOs.filter(
  //     (item) => item.function === 'no_function' && item.meshIOState === 'unassigned',
  //   );

  //   const a = [];
  //   for (const key in firePanelData.meshIos) {
  //     if (firePanelData.meshIos[key].serialNumber !== '') {
  //       a.push(firePanelData.meshIos[key].serialNumber);
  //     }
  //   }
  //   const filtered = intersection(arr, a);
  // }, [firePanelData.meshIos, firePanelData.siteId, meshIOs]);

  useEffect(() => {
    if (data && data?.siteId) {
      setFirePanelData(prev => ({ ...prev, siteId: data?.siteId }))
    }
  }, [data?.site, data, setFirePanelData]);

  const handleChange = useCallback(
    (name, value) => {
      if (name === 'name') {
        setFirePanelData(prev => ({ ...prev, name: value }))
      } else if (name === 'site') {
        setFirePanelData(prev => ({ ...prev, siteId: value }))
      }
    },
    [setFirePanelData],
  );

  const addMesh = useCallback(() => {
    let last = Object.keys(firePanelData.meshIos).length - 1;
    if (last < 0) {
      last = 0;
    } else {
      last = last + 1;
    }
    setFirePanelData(prev => ({
      ...prev, meshIos: {
        ...prev?.meshIos,
        [last]: {
          serialNumber: '',
          pins: [],
          show: false,
          name: '',
          selected: [],
          previous: [],
          local: true,
        }
      }
    }))
  }, [firePanelData.meshIos, setFirePanelData]);

  const hideShowMesh = useCallback(
    (key, status) => {
      setFirePanelData(prev => ({
        ...prev, meshIos: {
          ...prev?.meshIos,
          [key]: {
            ...prev?.meshIos[key],
            show: status
          }
        }
      }))
    },
    [setFirePanelData],
  );

  const deleteMesh = useCallback(
    (key) => {
      if (Object.keys(firePanelData.meshIos).length < 2) {
        setErrorDelete(
          'Cannot delete Mesh I/O. Minimum one Mesh I/O is required to assign with fire panel.',
        );
      } else {
        setFirePanelData(prev => {
          if (!prev?.meshIos) return prev;

          const updatedMeshIos = { ...prev.meshIos };
          delete updatedMeshIos[key];

          return { ...prev, meshIos: updatedMeshIos };
        });
      }
    },
    [setFirePanelData, firePanelData.meshIos],
  );

  const updateMeshData = useCallback(
    (key, id, status) => {
      setFirePanelData((prev) => {
        return {
          ...prev,
          meshIos: {
            ...prev.meshIos,
            [key]: {
              ...prev.meshIos[key],
              pins: prev.meshIos[key].pins.map((it) =>
                it.id === id ? { ...it, isEnabled: status } : it
              ),
            },
          },
        };
      });
    },
    [setFirePanelData],
  );

  const updatePinName = useCallback(
    (key, id, text) => {
      setFirePanelData((prev) => {
        return {
          ...prev,
          meshIos: {
            ...prev.meshIos,
            [key]: {
              ...prev.meshIos[key],
              pins: prev.meshIos[key].pins.map((it) =>
                it.id === id ? { ...it, name: text } : it
              ),
            },
          },
        };
      });
    },
    [setFirePanelData],
  );

  const addPins = useCallback(
    (key, serialNumber) => {
      const filtered = meshIOs.filter((item) => item.serialNumber === serialNumber);
      if (filtered.length > 0) {
        setFirePanelData((prev) => {
          return {
            ...prev,
            meshIos: {
              ...prev.meshIos,
              [key]: {
                ...prev.meshIos[key],
                serialNumber: serialNumber,
                pins: [
                  {
                    id: 9,
                    name: 'DI.04',
                    type: 'DI',
                    number: 4,
                    isEnabled: false,
                  },
                  {
                    id: 10,
                    name: 'DI.03',
                    type: 'DI',
                    number: 3,
                    isEnabled: false,
                  },
                  {
                    id: 11,
                    name: 'DI.02',
                    type: 'DI',
                    number: 2,
                    isEnabled: false,
                  },
                  {
                    id: 12,
                    name: 'DI.01',
                    type: 'DI',
                    number: 1,
                    isEnabled: false,
                  },
                ],
                selected: JSON.parse(JSON.stringify(filtered)),
              },
            },
          };
        });
      }
    },
    [meshIOs, setFirePanelData],
  );

  const Update = useCallback(() => {
    const body = {};
    const firePanelId = data.id;
    body.name = firePanelData.name;
    const tempMesh = [];
    Object.keys(firePanelData.meshIos).map((key) => {
      const temp = {};
      temp.serialNumber = firePanelData.meshIos[key].serialNumber;
      const arr = firePanelData.meshIos[key].pins.filter((item) => item.type === 'DI');
      temp.pins = arr;
      tempMesh.push(temp);
      return null;
    });
    body.meshIOs = tempMesh;

    dispatch(
      editFirePanel(currentPartner.partnerId, customerId, firePanelId, body, (status) => {
        if (status === 'success') {
          dispatch(doGetMeshList(currentPartner.partnerId, customerId));
          togglePopup && togglePopup('success');
        }
      }),
    );
  }, [
    currentPartner.partnerId,
    customerId,
    data.id,
    dispatch,
    firePanelData.meshIos,
    firePanelData.name,
    togglePopup,
  ]);

  useEffect(() => {
    if (Object.keys(firePanelData.meshIos).length > 0) {
      for (const key in firePanelData.meshIos) {
        if (firePanelData.meshIos.hasOwnProperty(key)) {
          if (firePanelData.meshIos[key].serialNumber === '') {
            setDisableButton(true);
            return;
          } else {
            setDisableButton(false);
          }
          // pins shudnt have empty string
          firePanelData.meshIos[key].pins.map((item) => {
            if (item.name === '') {
              setDisableButton(true);
            }
            return null;
          });
        }
      }
    } else {
      setDisableButton(true);
    }
  }, [firePanelData.meshIos, setDisableButton]);

  useEffect(() => {
    if (errorDelete !== '') {
      setTimeout(() => {
        setErrorDelete('');
      }, 5000);
    }
  }, [errorDelete]);

  // const getMeshIosToMap = useCallback((list1, list2, list3) => {
  //   const tempList = intersectionMesh(list1, list2);
  //   if (tempList.length > 0) {
  //     return [...list1, ...list3];
  //   } else {
  //     return [...list1, ...list2, ...list3];
  //   }
  // }, []);

  const filteredMeshData = meshIOs.filter((item) => item.networkId === firePanelData.networkId);

  const usedSerialNumbers = useMesh.flatMap((item) =>
    item.meshios.map((meshio) => meshio.serialNumber),
  );

  // Filter 'filteredMeshData' to remove the mesh IOs with used serial numbers
  const filteredUnusedMeshData = filteredMeshData.filter((meshItem) => {
    return !usedSerialNumbers.includes(meshItem.serialNumber);
  });

  return (
    <SDialog
      title='Edit Fire Panel'
      open={true}
      isFormDialog={true}
      width='50%'
      onClose={() => popupToggle(false)}
      secondaryButtonConfig={{
        text: 'Cancel',
        onClick: () => {
          popupToggle();
        }
      }}
      primaryButtonConfig={{
        text: 'Save',
        onClick: () => {
          Update();
        }
      }}
    >
      <FlexColumn alignItems='start'>
        <FlexRow justifyContent='start'>
          <FlexColumn styles={{ flex: '1 1 13rem' }}>
            <TextInput
              name="firePanelName"
              placeholder="Fire Panel Name"
              value={firePanelData.name}
              onChange={(e) => handleChange('name', e.target.value)}
            />
          </FlexColumn>
          <FlexColumn styles={{ flex: '1 1 13rem' }}>
            <TextInput
              placeholder="Site name"
              value={firePanelData.siteName}
              disabled={true}
              onChange={(value) => handleChange('siteName', value)}
            />
          </FlexColumn>
        </FlexRow>
        <FlexRow justifyContent='space-between'>
          <Typography variant={"h7M"}>Select Mesh I/O</Typography>
          <FlexRow width='fit-content'>
            {filteredUnusedMeshData.length === 0 && <p>No meshIOs</p>}
            <SButton
              variant={"secondary"}
              color={"grey"}
              onClick={() => {
                addMesh();
              }}
              disabled={
                firePanelData.name === '' ||
                firePanelData.siteId === '' ||
                filteredUnusedMeshData.length === 0
              }
            ><PlusIcon size={18} style={{ marginRight: '0.5rem' }} /> Add Mesh I/O</SButton>
          </FlexRow>
        </FlexRow>
        <div className={classnames(styles['container'])} style={{ padding: isMobile ? '0rem' : '0.5rem' }}>
          <div className="mrb-2">
            {Object.keys(firePanelData.meshIos).map((key, index) => {
              const mesh = getFilteredMesh(firePanelData.meshIos[key].serialNumber);
              const selectedvalue = mesh?.name ? mesh?.name : '';

              // const isSerialNumberExisting = Object.keys(firePanelData.meshIos)
              //   .filter((otherKey) => otherKey !== key) // Exclude the current key
              //   .some((otherKey) => {
              //     const otherMesh = firePanelData.meshIos[otherKey];
              //     const otherSerialNumber = otherMesh.serialNumber;
              //     return otherSerialNumber === mesh.serialNumber;
              //   });

              const filteredOptions = filteredUnusedMeshData.filter((option) => {
                const serialNumberMatch =
                  firePanelData.meshIos[key].serialNumber !== option.serialNumber;

                return serialNumberMatch;
              });

              return (
                <>
                  <div className="box-grey" style={isMobile ? { padding: '1rem 0.5rem' } : {}}>
                    <FlexRow justifyContent='space-between' alignItems='end'>
                      <FlexColumn width={isMobile ? 'fit-content' : '10rem'} styles={isMobile ? { flex: '1 1 100%', maxWidth: '100%' } : {}}>
                        <Dropdown
                          placeholder="Mesh I/O"
                          name="Mesh I/O"
                          value={selectedvalue}
                          onChange={(e) => {
                            addPins(key, e.serialNumber);
                          }}
                          data={filteredOptions}
                          disabled={data.meshios.some(
                            (item) => item.serialNumber === mesh?.serialNumber,
                          )}
                        />
                      </FlexColumn>
                      <FlexRow width='fit-content' justifyContent={isMobile ? 'space-between' : 'center'} styles={isMobile ? { flex: '1 1 100%' } : {}}>
                        <SButton
                          color={"grey"}
                          disabled={firePanelData.meshIos[key].serialNumber === ''}
                          onClick={() => {
                            hideShowMesh(key, !firePanelData.meshIos[key].show);
                          }}>
                          {firePanelData.meshIos[key].show ? 'Hide Details' : 'Show Details'}
                        </SButton>
                        <SquareDelete
                          color={'#ff535a'}
                          onPress={() => {
                            deleteMesh(key);
                          }}
                          style={{ width: '2.3rem', height: '2.3rem', padding: '0px', margin: '0' }}
                        />
                      </FlexRow>
                    </FlexRow>

                    {errorDelete !== '' && <p style={{ marginTop: '0.5rem' }} className={styles['error']}>{errorDelete}</p>}
                    {firePanelData.meshIos[key].show && (
                      <div className="mesh-container" style={{ margin: '1rem 0' }}>
                        <Mesh
                          isEditable
                          pinData={firePanelData.meshIos[key].pins}
                          handleChange={(id, status) => {
                            updateMeshData(key, id, status);
                          }}
                          onTextChange={(id, text) => {
                            updatePinName(key, id, text);
                          }}
                          title={firePanelData.meshIos[key].name}
                          isTextChangeable={true}
                        />
                      </div>
                    )}
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </FlexColumn>
    </SDialog>
  );
};

export default EditFirePanel;
